import React from "react";
import ReactDOM from "react-dom/client";
import AuthGate from "./auth";

// Sign-in and the access gate come first (auth.jsx); the hub (App.jsx) only
// mounts for office staff and crew.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AuthGate />);
